"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const polaris_1 = require("@amzn/awsui-components-react/polaris");
const change_case_1 = __importDefault(require("change-case"));
require("./index.css");
const SIGN_OUT_ID = 'sign_out';
const onClickOtherFrame = callback => {
    react_1.useEffect(() => {
        const handler = () => {
            if (document.activeElement && document.activeElement.tagName === 'IFRAME') {
                callback();
            }
        };
        window.addEventListener('blur', handler);
        return () => window.removeEventListener('blur', handler);
    });
};
/**
 * Profile dropdown component
 *
 * @param user the user details (must contain firstName, lastName, userName, and role)
 * @param availableProfiles array of available profiles
 * @param signOutUri URI to link to for signing out
 * @param switchProfileUri URI to link to for switching to a different profile.  Should contain "${username}"
 *      for dynamic substitution with the username clicked on
 */
const ProfileDropdown = ({ user, availableProfiles, signOutUri, switchProfileUri }) => {
    /**
     * Group array values into a dictionary by key.
     * @param array
     * @param key
     * @returns Dictionary with each distinct key from array values.  Values are
     * arrays of objects for the given key, sorted by role.
     */
    const groupBy = (array, key) => array.reduce((objectsByKeyValue, obj) => {
        const value = obj[key];
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj).sort((lhs, rhs) => {
            return lhs.role.localeCompare(rhs.role);
        });
        return objectsByKeyValue;
    }, {});
    // Group the profiles by organization
    const orgProfiles = groupBy(availableProfiles || [], 'organizationName');
    // Keep a consistent order of dropdown items (order by organization)
    const sortedKeys = Object.keys(orgProfiles).sort();
    const mappedProfiles = [];
    // dynamically create the content of the dropdown with separate sections for each organization
    sortedKeys.forEach(orgName => {
        const profilesForOrg = orgProfiles[orgName];
        mappedProfiles.push({
            text: orgName,
            items: profilesForOrg.map(p => ({
                text: `${change_case_1.default.titleCase(p.role)} (${p.userName})`,
                id: p.userName,
                disabled: p.userName === user.userName,
            })),
        });
    });
    // Begin adding content to the dropdown.  If there are any profiles, we need to add stuff before and after.
    let items = [];
    if (mappedProfiles.length > 0) {
        items.push({
            items: [
                {
                    text: 'Switch profile...',
                    disabled: true,
                },
            ],
        });
        items = items.concat(mappedProfiles);
    }
    items.push({
        items: [
            {
                text: 'Sign out',
                id: SIGN_OUT_ID,
            },
        ],
    });
    const onClick = event => {
        if (event.detail.id === SIGN_OUT_ID) {
            window.location.assign(signOutUri);
        }
        else {
            window.location.assign(switchProfileUri.replace('{username}', encodeURIComponent(event.detail.id)));
        }
    };
    // ButtonDropdowns normally close if you click outside, except it doesn't
    // work if you click in an iframe. So make it work.
    const domRef = react_1.useRef(null);
    onClickOtherFrame(() => {
        // close if expanded
        if (domRef && domRef.current && domRef.current.querySelector('.awsui-button-dropdown')) {
            const button = domRef.current.querySelector('button');
            button.click();
            button.blur();
        }
    });
    return (react_1.default.createElement("div", { className: "console-dropdown", ref: domRef },
        react_1.default.createElement(polaris_1.ButtonDropdown, { onItemClick: onClick, items: items, text: react_1.default.createElement("div", { className: "console-dropdown-text" },
                react_1.default.createElement("div", null, user.firstName && user.lastName
                    ? `${user.firstName} ${user.lastName}`
                    : 'System User'),
                react_1.default.createElement("div", { className: "console-dropdown-text-secondary" },
                    change_case_1.default.titleCase(user.role),
                    " (",
                    user.userName,
                    ")")) })));
};
ProfileDropdown.propTypes = {
    user: prop_types_1.default.object.isRequired,
    availableProfiles: prop_types_1.default.array,
    signOutUri: prop_types_1.default.string.isRequired,
    switchProfileUri: prop_types_1.default.string.isRequired,
};
ProfileDropdown.defaultProps = {
    availableProfiles: [],
};
exports.default = ProfileDropdown;
//# sourceMappingURL=ProfileDropdown.js.map